import classNames from 'classnames';
import type { ReactNode } from 'react';

export const CardTitle = ({
  children,
  className,
  withMargin = true,
}: {
  children: ReactNode | ReactNode[];
  className?: string;
  withMargin?: boolean;
}) => <div className={classNames('text-lg font-semibold', { 'mb-4 lg:mb-6': withMargin }, className)}>{children}</div>;
